import React, { useEffect, useState } from 'react';

import CButton from '../button/button';
import CInput from '../input/input';
import { Line, Space } from '../utils/utils';

import '../../theme/global.scss';
import { notify } from '../../notifications/notification';
import { editObservations } from '../../network/measure';
import { ILitigation } from '../../utils/interfaces/interfaces';
import { editLitigation } from '../../network/litigii';

interface IEditLitigationTextProps {
  callback: () => any;
  litigation: ILitigation;
  label: string;
  field: string;
  originalValue: string;
  readOnly: boolean;
}
const EditLitigationField = (props: IEditLitigationTextProps) => {
  const [value, setValue] = useState('');

  useEffect(() => {
    setValue(props.originalValue);
  }, [props.originalValue]);

  const handleSubmit = (event: React.MouseEvent) => {
    event.preventDefault();
    const payload = {} as any;
    payload[props.field] = value;
    console.log(props);
    editLitigation(props.litigation.id, payload).then(() => {
      props.callback();
    });
  };

  return (
    <form>
      <p className='body-dark bold'>{props.label}</p>
      <Line width={'80px'} />
      <Space vertical={'30px'} />
      {props.readOnly ? (
        props.originalValue ? (
          <p className='small-dark'>{props.originalValue}</p>
        ) : (
          <p className='small-dark info'>-</p>
        )
      ) : (
        <CInput
          id={props.field}
          name={props.field}
          label={props.label}
          type={props.field === 'term' ? 'date' : 'textarea'}
          placeholder={props.label}
          value={value}
          onChange={e => setValue(e.target.value)}
          required
          disabled={props.readOnly}
        />
      )}
      <Space vertical={'30px'} />
      {!props.readOnly && (
        <CButton label='Salveaza' type='submit' onClick={handleSubmit} />
      )}
    </form>
  );
};

export default EditLitigationField;
